import React from 'react';
import styled from 'styled-components';

import { BoldItalicUnderlineControls, ControlsWrapper } from 'components/composer/shared/editor_controls_new';
import { Attachment, Emoji } from 'components/composer/shared/editor_action_buttons_new';
import { EditorContainer } from './shared/editor_new';
import AddTask from 'actions/composition/add_task';
import EditTask from 'actions/composer/edit_task';
import Composer, { Header, HeaderText } from './shared/composer_new';
import ComposerEditor from './shared/composer_editor';
import useComposer from './shared/use_composer';
import useEditor from './shared/use_editor';
import useRichTextEditorPlugins from 'components/text_editor_new/hooks/use_rich_text_editor_plugins';
import serializeHtml from 'components/text_editor_new/lib/serialize_html_external';
import DatePicker from 'components/composer/shared/date_picker';
import AssigneeSelector from 'components/composer/shared/assignee_selector';

const LeftWrapper = styled.div`
  display: flex;
`;

const submitTextForCreateOrEdit = isEditing => (isEditing ? 'Save Task' : 'Add Task');
const headerTextForCreateOrEdit = isEditing => (isEditing ? 'Edit Task' : 'Create Task');
const taskForCreateOrEdit = isEditing => (isEditing ? EditTask : AddTask);

export function TaskComposer({ isEditing }) {
  const composerProps = useComposer({
    action: taskForCreateOrEdit(isEditing),
    options: { trimEmptyParagraphs: true, trimParagraphWhitespace: true },
  });
  const editorProps = useEditor('bodyHtml', composerProps, { serializer: serializeHtml });
  const editorRef = useRichTextEditorPlugins(composerProps, editorProps);

  return (
    <Composer
      defaultEditor={editorRef.current}
      defaultEditorId={editorProps.editorId}
      defaultOnChange={editorProps.onChange}
      includeAttachments
      initialHtml={editorProps.initialHtml}
      submitText={submitTextForCreateOrEdit(isEditing)}
      {...composerProps}
    >
      <Header>
        <LeftWrapper>
          <HeaderText>{headerTextForCreateOrEdit(isEditing)}</HeaderText>
          <DatePicker />
        </LeftWrapper>
        <AssigneeSelector />
      </Header>
      <ControlsWrapper>
        <BoldItalicUnderlineControls {...editorProps} />
        <Emoji {...editorProps} />
        <Attachment alwaysShow />
      </ControlsWrapper>
      <EditorContainer includeAttachments>
        <ComposerEditor placeholder="Type to enter task description" {...editorProps} />
      </EditorContainer>
    </Composer>
  );
}

export default React.memo(TaskComposer);
